export const menuItemArr = [
  {
    id: 1,
    // label: "首页",
    label: "数据看板",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 2,
    label: "内容管理",
    icon: "bx-news",
    power: ["创作平台-文章发布", "创作平台-视频发布"],
    subItems: [
      {
        id: 3,
        label: "文章发布",
        link: "/articlePublish",
        parentId: 2,
        power: ["创作平台-文章发布"],
      },
      {
        id: 4,
        label: "视频发布",
        link: "/videoPublish",
        parentId: 2,
        power: ["创作平台-视频发布"],
      },
    ],
  },
  /* 话题管理 */
  {
    id: 350,
    label: "话题管理",
    icon: "el-icon-chat-line-round",
    link: "/topicManage",
    power: ["话题-列表"],
  },
  {
    id: 120,
    label: "答题管理",
    icon: "el-icon-question",
    power: ["创作平台-问卷管理", "创作平台-题库管理"],
    subItems: [
      {
        id: 121,
        label: "问卷管理",
        link: "/questionManage",
        parentId: 120,
        power: ["创作平台-问卷管理"],
      },
      {
        id: 122,
        label: "题库管理",
        link: "/questionBank",
        parentId: 120,
        power: ["创作平台-题库管理"],
      },
    ],
  },
  {
    id: 5,
    label: "媒体号管理",
    icon: "bx-news",
    power: [
      "创作平台-媒体号管理",
      "创作平台-圈子管理",
      "创作平台-运营人员管理",
      "创作平台-圈子评论管理",
      "创作平台-角色管理",
    ],
    subItems: [
      {
        id: 10,
        label: "媒体号管理",
        link: "/media",
        parentId: 5,
        power: ["创作平台-媒体号管理"],
      },
      {
        id: 6,
        label: "圈子管理",
        link: "/group",
        parentId: 5,
        power: ["创作平台-圈子管理"],
      },
      {
        id: 7,
        label: "运营人员管理",
        link: "/operator",
        parentId: 5,
        power: ["创作平台-运营人员管理"],
      },
      {
        id: 8,
        label: "圈子评论管理",
        link: "/circleReview",
        parentId: 5,
        power: ["创作平台-圈子评论管理"],
      },
      {
        id: 9,
        label: "角色管理",
        link: "/mediaRole",
        parentId: 5,
        power: ["创作平台-角色管理"],
      },
    ],
  },
  {
    id: 124,
    label: "运营活动管理",
    link: "/operationActivity",
    icon: "el-icon-s-data",
    power: ["创作平台-运营活动管理"],
  },
  {
    id: 11,
    label: "用户中心",
    link: "/userInfo",
    icon: "bx-user",
    power: ["创作平台-用户中心"],
  },
];
